import React, { useEffect, useState } from 'react';
import { INPUT_DEBOUNCE_TIME } from '../../lib/constants';

export interface SearchResultsStatusProps {
  count: number;
  searchValue: string;
  className?: string;
  as?: 'div' | 'section';
}

const ANNOUNCE_DELAY_MS = INPUT_DEBOUNCE_TIME;

const formatSearchResultsMessage = (count: number, searchValue: string): string => {
  const trimmedQuery = searchValue.trim();
  const resultWord = count === 1 ? 'result' : 'results';
  const countLabel = count === 0 ? 'no' : String(count);
  return `${countLabel} search ${resultWord} for “${trimmedQuery}”`;
};


const SearchResultsStatus = (props: SearchResultsStatusProps): JSX.Element => {
  const {
    count,
    searchValue,
    className,
    as: Tag = 'div'
  } = props;

  const message = formatSearchResultsMessage(count, searchValue);
  const [announcement, setAnnouncement] = useState('');

  // Hold the announcement back until typing settles so the screen reader speaks
  // only the final count, not every intermediate one.
  useEffect(() => {
    setAnnouncement('');
    const timeoutId = window.setTimeout(() => setAnnouncement(message), ANNOUNCE_DELAY_MS);

    return () => window.clearTimeout(timeoutId);
  }, [message]);

  return (
    <Tag
      className={className}
      role='status'
      aria-live='polite'
      aria-atomic='true'
      data-test-id='search-results-status'
    >
      {announcement}
    </Tag>
  );
};

export { SearchResultsStatus, formatSearchResultsMessage, ANNOUNCE_DELAY_MS };
